module.exports = __webpack_public_path__ + "img/tv.532f9836.png";